import { isNotUndefined } from "@faire/typescript";

type ICssVarsArguments<CssVarsType extends ICssVars> = {
  [key in keyof CssVarsType]?: string | number | boolean | undefined;
};

export type ICssVars = Record<string, string>;

export interface IVarsGenOptions<CssVarsType extends ICssVars> {
  vars?: CssVarsType;
  defaultVarsValues?: ICssVarsArguments<CssVarsType>;
}

export type IVarsGenReturn<CssVarTypes extends ICssVars> = (
  cssVars: ICssVarsArguments<CssVarTypes>
) => Record<CssVarTypes[keyof CssVarTypes], string | undefined>;

export function cssVars<CssVarTypes extends ICssVars>(
  options: IVarsGenOptions<CssVarTypes>
) {
  const { vars, defaultVarsValues } = options;

  return (cssVarsArgs?: ICssVarsArguments<CssVarTypes>) => {
    if (!vars || (!cssVarsArgs && !defaultVarsValues)) {
      return {};
    }

    const computedVars: Record<string, string | undefined> = {};

    Object.entries(vars).forEach(([varAlias, varName]) => {
      const defaultValue = defaultVarsValues?.[varAlias];
      const value = cssVarsArgs?.[varAlias];

      const computedVar = value ?? defaultValue;

      if (isNotUndefined(computedVar)) {
        computedVars[`--${varName}`] = computedVar.toString();
      }
    });

    return computedVars;
  };
}
